import React from "react";
import { NavLink } from "react-router-dom";
import { CalendarClock, Users, LineChart } from "lucide-react";

/**
 * Bottom navigation for the mobile-first Care Team portal.
 *
 * Three top-level surfaces:
 *   • My Roster        → /staff/my-roster
 *   • Clients          → /staff/my-clients
 *   • My Performance   → /staff/my-performance
 *
 * Rendered as a fixed bar on small screens and a horizontal top-tab bar
 * on ≥sm screens so the same component covers both mobile phones and
 * iPads without a second layout.
 */
const TABS = [
  { to: "/staff/my-roster", label: "My Roster", Icon: CalendarClock, testid: "care-tab-roster" },
  { to: "/staff/my-clients", label: "Clients", Icon: Users, testid: "care-tab-clients" },
  { to: "/staff/my-performance", label: "My Performance", Icon: LineChart, testid: "care-tab-performance" },
];

export default function CareTeamTabs() {
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-30 border-t border-border bg-white/95 backdrop-blur sm:static sm:border-t-0 sm:border-b sm:bg-transparent sm:backdrop-blur-0"
      data-testid="care-team-tabs"
    >
      <div className="max-w-2xl mx-auto grid grid-cols-3 sm:flex sm:gap-1 sm:px-3 sm:py-2">
        {TABS.map(({ to, label, Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            end
            data-testid={testid}
            className={({ isActive }) =>
              [
                "flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 px-2 py-2 sm:px-4 sm:py-2 rounded-none sm:rounded-full text-[11px] sm:text-sm transition-colors",
                isActive
                  ? "text-primary font-semibold sm:bg-primary sm:text-primary-foreground sm:font-semibold"
                  : "text-muted-foreground hover:text-foreground sm:hover:bg-secondary",
              ].join(" ")
            }
          >
            <Icon className="w-5 h-5 sm:w-4 sm:h-4" />
            <span className="leading-none truncate">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
